import React, { useState, useEffect, useRef } from "react";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { IconButton } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import DeleteIcon from "@mui/icons-material/Delete";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Tooltip } from "@mui/material";
import { Icon } from "@iconify/react";
import {
  formatWithLeadingZeros,
  is_small_medium_screen,
} from "src/utils/constant";
import { s3baseUrl } from "src/config/config";

const EventCard = ({
  workout,
  handleReorder,
  isWorkoutSelected,
  editWorkputData,
  isFirstEventOnDate,
  isLastEventOnDate,
  handleScrollCalled,
  handleCopyExercise,
  handleAgreeDelete,
  setEditWorkputData,
  setEvents,
  events,
  handleUpdateIteration,
  is_show_only,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const timeoutRef = useRef(null);

  let work_out = workout?._def?.extendedProps;

  useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, []);

  const getMinutesForInterval = (mainindex, index) => {
    const list = [...work_out.workout_exercises];
    const interval = list[mainindex].interval_duration;
    if (interval <= 60) {
      return index + 1;
    }
    if (interval % 60 == 0) {
      return `${
        (interval / 60) * index +
        1 +
        " – " +
        ((interval / 60) * index + interval / 60)
      }`;
    }
    let startInterval = interval * index;
    let endtInterval = interval * index + interval;
    let startintervalText =
      interval * index
        ? Math.floor(startInterval / 60) +
          " " +
          ":" +
          formatWithLeadingZeros(startInterval % 60)
        : 0;
    let endIntervalText =
      Math.floor(endtInterval / 60) +
      " " +
      ":" +
      formatWithLeadingZeros(endtInterval % 60);

    return `${startintervalText + " – " + endIntervalText}`;
  };

  const handleMouseEnter = () => {
    clearTimeout(timeoutRef.current);
    setIsHovered(true);
  };

  const moveEventUp = (eventId) => {
    setEditWorkputData(eventId);
    const eventIndex = events.findIndex(
      (event) => event.index === eventId.index,
    );

    if (eventIndex > 0 && eventIndex !== -1) {
      const temp = events[eventIndex];

      events[eventIndex] = events[eventIndex - 1];
      events[eventIndex - 1] = temp;
      [events[eventIndex].order, events[eventIndex - 1].order] = [
        events[eventIndex - 1].order,
        events[eventIndex].order,
      ];
      [events[eventIndex].index, events[eventIndex - 1].index] = [
        events[eventIndex - 1].index,
        events[eventIndex].index,
      ];

      const changedDateEvents = events.filter(
        (event) => event.workout_date === eventId.workout_date,
      );
      setEvents([...events]);
      handleReorder(changedDateEvents);

      setTimeout(() => {
        handleScrollCalled(eventId._id);
      }, 0);
    }
  };

  const moveEventDown = (eventId) => {
    setEditWorkputData(eventId);
    const eventIndex = events.findIndex(
      (event) => event.index === eventId.index,
    );

    if (eventIndex < events.length - 1 && eventIndex !== -1) {
      const temp = events[eventIndex];
      events[eventIndex] = events[eventIndex + 1];
      events[eventIndex + 1] = temp;

      [events[eventIndex].order, events[eventIndex + 1].order] = [
        events[eventIndex + 1].order,
        events[eventIndex].order,
      ];
      [events[eventIndex].index, events[eventIndex + 1].index] = [
        events[eventIndex + 1].index,
        events[eventIndex].index,
      ];

      const changedDateEvents = events.filter(
        (event) => event.workout_date === eventId.workout_date,
      );

      setEvents([...events]);
      handleReorder(changedDateEvents);

      setTimeout(() => {
        handleScrollCalled(eventId._id);
      }, 0);
    }
  };

  const handleMouseLeave = () => {
    const delay = 300;
    timeoutRef.current = setTimeout(() => {
      setIsHovered(false);
    }, delay);
  };

  return (
    <div
      className="calendar-workout-card"
      id={work_out?._id}
      style={{
        boxShadow: isWorkoutSelected(work_out)
          ? "-2px -2px 7px 1px #04abbb, 1px 1px 7px 2px #04abbb"
          : "",
        border:
          editWorkputData?._id == work_out?._id
            ? "2px solid var(--portal-theme-primary)"
            : "0px solid var(--portal-theme-primary)",
        borderTopRightRadius: "7px",
        borderTopLeftRadius: "7px",
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {!is_show_only && (
        <>
          {is_small_medium_screen() ? (
            <div className="w-100 h-100" onMouseEnter={handleMouseEnter}>
              {
                <div className="all-icon-calendar-workout-general-small-screen d-flex w-100 justify-content-between">
                  <div className="d-flex">
                    <Tooltip
                      title={`${
                        work_out.is_deleteAble
                          ? "Delete"
                          : "Can't be deleted, This workout has results."
                      }`}
                    >
                      <DeleteIcon
                        className={`${
                          work_out.is_deleteAble
                            ? "del-icon-calendar-workout-general"
                            : "del-icon-calendar-workout-disabled-general"
                        }`}
                        onClick={
                          work_out.is_deleteAble
                            ? () => handleAgreeDelete(work_out)
                            : () => {}
                        }
                      />
                    </Tooltip>
                    <Tooltip title={`${"Copy"}`}>
                      <div
                        className={`${"copy-icon-calendar-workout-general ms-1 d-flex justify-content-center align-items-center"}`}
                      >
                        <ContentCopyIcon
                          sx={{ width: 17, height: 17 }}
                          onClick={() => handleCopyExercise(work_out)}
                        />
                      </div>
                    </Tooltip>
                  </div>
                  <div className="d-flex">
                    {" "}
                    <Tooltip title="Move Up">
                      <div className="arrow-icon-calendar-workout-general ms-1 d-flex justify-content-center align-items-center">
                        <IconButton disabled={isFirstEventOnDate(work_out)}>
                          <KeyboardArrowUpIcon
                            sx={{ width: 17, height: 17 }}
                            onClick={() => moveEventUp(work_out)}
                          />
                        </IconButton>
                      </div>
                    </Tooltip>{" "}
                    <Tooltip title="Move Down">
                      <div className="arrow-icon-calendar-workout-general ms-1 d-flex justify-content-center align-items-center">
                        <IconButton disabled={isLastEventOnDate(work_out)}>
                          <KeyboardArrowDownIcon
                            sx={{ width: 17, height: 17 }}
                            onClick={() => moveEventDown(work_out)}
                          />
                        </IconButton>
                      </div>
                    </Tooltip>{" "}
                  </div>
                </div>
              }
            </div>
          ) : (
            <div className="w-100 h-100" onMouseEnter={handleMouseEnter}>
              {isHovered && (
                <div className="all-icon-calendar-workout-general d-flex w-100 justify-content-between">
                  <div className="d-flex">
                    <Tooltip
                      title={`${
                        work_out.is_deleteAble
                          ? "Delete"
                          : "Can't be deleted, This workout has results."
                      }`}
                    >
                      <DeleteIcon
                        className={`${
                          work_out.is_deleteAble
                            ? "del-icon-calendar-workout-general"
                            : "del-icon-calendar-workout-disabled-general"
                        }`}
                        onClick={
                          work_out.is_deleteAble
                            ? () => handleAgreeDelete(work_out)
                            : () => {}
                        }
                      />
                    </Tooltip>
                    <Tooltip title={`${"Copy"}`}>
                      <div
                        className={`${"copy-icon-calendar-workout-general ms-1 d-flex justify-content-center align-items-center"}`}
                      >
                        <ContentCopyIcon
                          sx={{ width: 17, height: 17 }}
                          onClick={() => handleCopyExercise(work_out)}
                        />
                      </div>
                    </Tooltip>
                  </div>
                  <div className="d-flex">
                    {" "}
                    <Tooltip title="Move Up">
                      <div className="arrow-icon-calendar-workout-general ms-1 d-flex justify-content-center align-items-center">
                        <IconButton disabled={isFirstEventOnDate(work_out)}>
                          <KeyboardArrowUpIcon
                            sx={{ width: 17, height: 17 }}
                            onClick={() => moveEventUp(work_out)}
                          />
                        </IconButton>
                      </div>
                    </Tooltip>{" "}
                    <Tooltip title="Move Down">
                      <div className="arrow-icon-calendar-workout-general ms-1 d-flex justify-content-center align-items-center">
                        <IconButton disabled={isLastEventOnDate(work_out)}>
                          <KeyboardArrowDownIcon
                            sx={{ width: 17, height: 17 }}
                            onClick={() => moveEventDown(work_out)}
                          />
                        </IconButton>
                      </div>
                    </Tooltip>{" "}
                  </div>
                </div>
              )}
            </div>
          )}
        </>
      )}

      <div onMouseEnter={handleMouseEnter}>
        <div
          className="calendar-workout-card-title"
          style={{
            backgroundColor: work_out.workout_color,
          }}
          onMouseEnter={handleMouseEnter}
        >
          <div
            className="calendar-workout-card-program"
            onClick={() => handleUpdateIteration(work_out)}
          >
            {work_out?.workout_program?.title}
          </div>
          <div
            className="d-flex justify-content-between"
            onMouseEnter={handleMouseEnter}
          >
            <div
              className="calendar-workout-card-workout"
              onClick={() => handleUpdateIteration(work_out)}
              onMouseEnter={handleMouseEnter}
            >
              {workout?.title}
            </div>
            <div
              className="d-flex align-items-center"
              onMouseEnter={handleMouseEnter}
            >
              <Icon
                onClick={() => handleUpdateIteration(work_out)}
                icon={
                  work_out.practice_type == "workout" ||
                  work_out.library_type == "workout-type"
                    ? "mdi:gym"
                    : work_out.practice_type == "food" ||
                      work_out.library_type == "meal-type"
                    ? "fluent:food-24-filled"
                    : work_out.practice_type == "mindset" ||
                      work_out.library_type == "mindset-type"
                    ? "flowbite:brain-outline"
                    : work_out.practice_type == "video"
                    ? "lets-icons:video-fill"
                    : work_out.practice_type == "comment"
                    ? "mdi:comment-text"
                    : "mdi:gym"
                }
                className="workout-type-icon-container "
              />
              {!work_out?.open ? (
                <KeyboardArrowDownIcon
                  sx={{
                    cursor: "pointer",
                    opacity: 0.7,
                    fontSize: "20px",
                  }}
                  onClick={() => {
                    const list = [...events];
                    list[work_out.index]["open"] = true;
                    setEvents(list);
                  }}
                />
              ) : (
                <KeyboardArrowUpIcon
                  sx={{
                    cursor: "pointer",
                    opacity: 0.7,
                    fontSize: "20px",
                  }}
                  onClick={() => {
                    const list = [...events];
                    list[work_out.index]["open"] = false;
                    setEvents(list);
                  }}
                />
              )}
            </div>
          </div>
        </div>
        {work_out?.open && (
          <div
            className="calendar-workout-card-exercises"
            onMouseEnter={handleMouseEnter}
          >
            <div
              className="calendar-workout-card-container py-1"
              onMouseEnter={handleMouseEnter}
              onClick={() => handleUpdateIteration(work_out)}
            >
              {work_out.practice_type == "workbook" ? (
                <>
                  <div
                    className="inner-div workout-calendar-exercise-card my-1"
                    style={{
                      whiteSpace: "break-spaces",
                    }}
                  >
                    {work_out?.workout_title}
                  </div>
                </>
              ) : (
                <></>
              )}
              {work_out.practice_type == "video" ? (
                <>
                  <div className="inner-div workout-calendar-exercise-card my-1">
                    {work_out?.dumyImage ? (
                      <div
                        style={{
                          whiteSpace: "break-spaces",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          className="image-border"
                          src={work_out?.dumyImage}
                          height="50"
                        />
                      </div>
                    ) : (
                      <div
                        style={{
                          whiteSpace: "break-spaces",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          className="image-border"
                          src={
                            s3baseUrl + work_out?.video_thumbnail?.thumbnail_1
                          }
                          height="50"
                        />
                      </div>
                    )}
                  </div>
                </>
              ) : (
                <></>
              )}
              {work_out.practice_type == "comment" ? (
                <>
                  <div
                    className="inner-div workout-calendar-exercise-card my-1"
                    style={{
                      fontSize: "11px",
                      overflow: "hidden",
                      whiteSpace: "break-spaces",
                    }}
                  >
                    {work_out?.comment || ""}
                  </div>
                </>
              ) : (
                <></>
              )}
              {work_out.workout_exercises.map((exercise, index) => {
                if (exercise?.exercise_type == "something_else") {
                  return (
                    <div className="inner-div workout-calendar-exercise-card my-1">
                      <div
                        style={{
                          whiteSpace: "break-spaces",
                        }}
                      >
                        {exercise?.title}
                      </div>
                    </div>
                  );
                } else if (
                  exercise?.exercise_type == "amrap" &&
                  exercise?.emom_amrap &&
                  exercise?.emom_amrap.length > 0
                ) {
                  return (
                    <div className="workout-calendar-Superset-card inner-div my-1">
                      <div className="text-center">AMRAP</div>
                      {exercise?.emom_amrap?.map((interval, intervalIndex) => {
                        return (
                          <div className="my-1">
                            <div style={{ fontSize: "8px" }}>Movements</div>
                            {interval?.map((exerData) => {
                              return (
                                <div
                                  className="inner-div"
                                  style={{
                                    whiteSpace: "break-spaces",
                                    marginBottom: "3px",
                                  }}
                                >
                                  {exerData?.exercise_info?.title}
                                </div>
                              );
                            })}
                          </div>
                        );
                      })}
                    </div>
                  );
                } else if (
                  exercise?.exercise_type == "rounds_for_time" &&
                  exercise?.emom_amrap &&
                  exercise?.emom_amrap.length > 0
                ) {
                  return (
                    <div className="workout-calendar-Superset-card inner-div my-1">
                      <div className="text-center">Rounds For Time</div>
                      {exercise?.emom_amrap?.map((interval) => {
                        return (
                          <div className="my-1">
                            <div style={{ fontSize: "8px" }}>Movements</div>
                            {interval?.map((exerData) => {
                              return (
                                <div
                                  className="inner-div"
                                  style={{
                                    whiteSpace: "break-spaces",
                                    marginBottom: "3px",
                                  }}
                                >
                                  {exerData?.exercise_info?.title}
                                </div>
                              );
                            })}
                          </div>
                        );
                      })}
                    </div>
                  );
                } else if (
                  exercise?.exercise_type == "reps_for_time" &&
                  exercise?.emom_amrap &&
                  exercise?.emom_amrap.length > 0
                ) {
                  return (
                    <div className="workout-calendar-Superset-card inner-div my-1">
                      <div className="text-center">Reps For Time</div>
                      {exercise?.emom_amrap?.map((interval, intervalIndex) => {
                        return (
                          <div className="my-1">
                            <div style={{ fontSize: "8px" }}>Movements</div>
                            {interval?.map((exerData) => {
                              return (
                                <div
                                  className="inner-div"
                                  style={{
                                    whiteSpace: "break-spaces",
                                    marginBottom: "3px",
                                  }}
                                >
                                  {exerData?.exercise_info?.title}
                                </div>
                              );
                            })}
                          </div>
                        );
                      })}
                    </div>
                  );
                } else if (
                  exercise?.exercise_type == "emom" &&
                  exercise?.emom_amrap &&
                  exercise?.emom_amrap.length > 0
                ) {
                  return (
                    <div className="workout-calendar-Superset-card inner-div my-1">
                      <div className="text-center">EMOM</div>
                      {exercise?.emom_amrap?.map((interval, intervalIndex) => {
                        return (
                          <div className="my-1">
                            <div style={{ fontSize: "8px" }}>
                              Minute{" "}
                              {getMinutesForInterval(index, intervalIndex)}
                            </div>
                            {interval?.map((exerData) => {
                              return (
                                <div
                                  className="inner-div"
                                  style={{
                                    whiteSpace: "break-spaces",
                                    marginBottom: "3px",
                                  }}
                                >
                                  {exerData?.exercise_info?.title}
                                </div>
                              );
                            })}
                          </div>
                        );
                      })}
                    </div>
                  );
                } else if (
                  exercise?.sub_exercises &&
                  exercise?.sub_exercises.length > 0
                ) {
                  return (
                    <div className="workout-calendar-Superset-card inner-div my-1">
                      {exercise?.sub_exercises?.map((exerData, exerIndex) => {
                        return (
                          <div
                            className="inner-div"
                            style={{
                              whiteSpace: "break-spaces",
                              marginBottom: "3px",
                            }}
                          >
                            {exerData?.exercise_info?.title}
                          </div>
                        );
                      })}
                    </div>
                  );
                } else
                  return (
                    <div className="inner-div workout-calendar-exercise-card my-1">
                      <div
                        style={{
                          whiteSpace: "break-spaces",
                        }}
                      >
                        {exercise?.exercise_info?.title}
                      </div>
                    </div>
                  );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EventCard;
